import React from 'react';

export const Pagination: React.FC<{ page: number; total: number; limit: number; onChange: (p: number) => void }> = ({ page, total, limit, onChange }) => {
  const pages = Math.max(1, Math.ceil(total / limit));
  return (
    <div className="flex justify-between items-center text-sm text-text-muted py-2">
      <div>Page {page} of {pages} · {total} total</div>
      <div className="flex gap-2">
        <button disabled={page <= 1} onClick={() => onChange(page - 1)} className="px-3 py-1 rounded border border-border disabled:opacity-40">Prev</button>
        <button disabled={page >= pages} onClick={() => onChange(page + 1)} className="px-3 py-1 rounded border border-border disabled:opacity-40">Next</button>
      </div>
    </div>
  );
};
